import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import Layout from "./Layout";
import Home from "./pages/Home";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import ProductDetails from "./pages/ProductDetails";
import ProductListing from "./pages/ProductListing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import CompleteProfile from "./pages/CompleteProfile";
import CartPage from "./pages/CartPage";
import CheckoutPage from "./pages/CheckoutPage";
import PaymentError from "./pages/PaymentError";
import PaymentSuccess from "./pages/PaymentSuccess";
import MyOrders from "./pages/MyOrders";
import OrderDetails from "./pages/OrderDetails";
import RepaymentPage from "./pages/RepaymentPage";

import i18n from "./i18n";
import ForgotPassword from "./pages/ForgetPassword";
import ResetPassword from "./pages/ResetPassword";
import AboutUs from "./pages/About";
function App() {

   useEffect(() => {
    // Set the dir attribute based on the current language
    const currentLang = i18n.language || 'en';
    const isRTL = ['ar', 'he', 'ur'].includes(currentLang);
    document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
    document.documentElement.setAttribute('lang', currentLang);

    // Optional: listen for future language changes
    i18n.on('languageChanged', (lng) => {
      const isRTL = ['ar', 'he', 'ur'].includes(lng);
      document.documentElement.setAttribute('dir', isRTL ? 'rtl' : 'ltr');
      document.documentElement.setAttribute('lang', lng);
    });

    return () => {
      i18n.off('languageChanged'); // cleanup listener on unmount
    };
  }, []);
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route index element={<Home />} />
            <Route path="about" element={<AboutUs />} />
            <Route path="login" element={<Login />} />
            <Route path="register" element={<Register />} />
            <Route path="forget-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="products/:categoryName" element={<ProductListing />} />
            <Route
              path="product/:id/:productName"
              element={<ProductDetails />}
            />
            <Route path="update" element={<CompleteProfile />} />
            <Route path="cart" element={<CartPage />} />
            <Route path="/checkout" element={<CheckoutPage />} />
            <Route path="/paymenterror" element={<PaymentError />} />
            <Route path="/paymentsuccess" element={<PaymentSuccess />} />
            <Route path="/orders" element={<MyOrders />} />
            <Route path="/orderdetails" element={<OrderDetails />} />
            <Route path="/orders/:orderId/pay" element={<RepaymentPage />} />
          </Route>
        </Routes>
      </Router>
      <ToastContainer autoClose={3000} />
    </>
  );
}

export default App;
